import { render, staticRenderFns } from "./PrimeCostCopyForm.vue?vue&type=template&id=58dfd5e6&"
import script from "./PrimeCostCopyForm.vue?vue&type=script&lang=ts&"
export * from "./PrimeCostCopyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports